import { handleActions } from "redux-actions";
import {
  SET_LOADING,
  SET_MODULE_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_PREFERENCES_SUCCESS,
  UPDATE_PREFERENCES_SUCCESS,
  FETCH_CLIENT_INFO_SUCCESS,
  FETCH_CLIENT_VISITS_SUCCESS,
  FETCH_CLIENT_SALES_SUCCESS,
  FETCH_CLIENT_PAST_DUES_SUCCESS,
  FETCH_CLIENT_CONTRACTS_SUCCESS,
  FETCH_CONTRACTS_STATUSES_SUCCESS,
  FETCH_CONTRACTS_FREEZES_SUCCESS,
  FETCH_CLIENT_CONTACT_LOGS_SUCCESS,
  FETCH_CLIENT_CHARTS_SUCCESS,
  FETCH_PIE_CHART_SUCCESS,
  FETCH_DATA_ERROR,
  SEND_CONTACT_LOG_REQUEST_SUCCESS,
  SET_CLIENT_LOGS_LOADING,
  SET_API_ERROR,
  FETCH_CLIENT_MEMBERSHIP_TYPES_SUCCESS,
  FETCH_CLIENT_PROSPECT_TYPES_SUCCESS,
  FETCH_CLIENT_CHECKINS_SUCCESS,
  FETCH_REMAINING_SESSIONS_SUCCESS
} from "./clientProfileSaga";

export const initialState = {
  currentUser: {},
  loadingModules: {
    membershipTypes: true,
    sales: true,
    pieCharts: true,
    prospectypes: true,
    pastdues: true,
    salesAndVisitsData: true,
    visits: true,
    contactLogs: true,
    freezes: true,
    contractsAgreements: true,
    membershipStatuses: true,
    checkIns: true,
    remainingSessions: true,
  },
  clientInfo: {},
  clientVisits: {},
  clientSales: {},
  clientPastDues: {},
  clientCheckIns: {},
  clientContactLogs: {
    tableInfo: {
      data: []
    }
  },
  contractStatuses: {
    tableInfo: {
      data: []
    }
  },
  contractFreezes: {
    tableInfo: {
      data: []
    }
  },
  clientContracts: {
    tableInfo: {
      data: []
    }
  },
  clientMembershipTypes: {
    tableInfo: {
      data: []
    }
  },
  pieCharts: {
    visits_by_class: [],
    visits_by_instructor: [],
    visits_by_status: [],
    revenue_by_product_name: []
  },
  preferences: [],
  clientCharts: {},
  haveError: false,
  error: "",
  isLoading: true,
  clientLogsLoading: true,
  apiError: false
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_MODULE_LOADING]: (state, action) => ({
      ...state,
      loadingModules: { ...state.loadingModules, ...action.payload }
    }),
    [SET_CLIENT_LOGS_LOADING]: (state, action) => ({
      ...state,
      clientLogsLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser
    }),
    [FETCH_PREFERENCES_SUCCESS]: (state, action) => ({
      ...state,
      preferences: action.payload
    }),
    [UPDATE_PREFERENCES_SUCCESS]: (state, action) => ({
      ...state,
      preferences: action.payload
    }),
    [FETCH_CLIENT_INFO_SUCCESS]: (state, action) => ({
      ...state,
      clientInfo: action.payload || state.clientInfo
    }),
    [FETCH_CLIENT_VISITS_SUCCESS]: (state, action) => ({
      ...state,
      clientVisits: action.payload || state.clientVisits
    }),
    [FETCH_CLIENT_SALES_SUCCESS]: (state, action) => ({
      ...state,
      clientSales: action.payload || state.clientSales
    }),
    [FETCH_CLIENT_PAST_DUES_SUCCESS]: (state, action) => ({
      ...state,
      clientPastDues: action.payload || state.clientPastDues
    }),
    [FETCH_CLIENT_MEMBERSHIP_TYPES_SUCCESS]: (state, action) => ({
      ...state,
      clientMembershipTypes: action.payload || state.clientMembershipTypes
    }),
    [FETCH_CLIENT_PROSPECT_TYPES_SUCCESS]: (state, action) => ({
      ...state,
      clientProspectTypes: action.payload || state.clientProspectTypes
    }),
    [FETCH_CLIENT_CONTRACTS_SUCCESS]: (state, action) => ({
      ...state,
      clientContracts: action.payload || state.clientContracts
    }),
    [FETCH_CONTRACTS_STATUSES_SUCCESS]: (state, action) => ({
      ...state,
      contractStatuses: action.payload || state.contractStatuses
    }),
    [FETCH_CONTRACTS_FREEZES_SUCCESS]: (state, action) => ({
      ...state,
      contractFreezes: action.payload || state.contractFreezes
    }),
    [FETCH_CLIENT_CONTACT_LOGS_SUCCESS]: (state, action) => ({
      ...state,
      clientContactLogs: action.payload || state.clientContactLogs
    }),
    [SEND_CONTACT_LOG_REQUEST_SUCCESS]: (state, action) => ({
      ...state,
      clientContactLogs: action.payload || state.clientContactLogs
    }),
    [FETCH_CLIENT_CHARTS_SUCCESS]: (state, action) => ({
      ...state,
      clientCharts: action.payload || state.clientCharts
    }),
    [FETCH_CLIENT_CHECKINS_SUCCESS]: (state, action) => ({
      ...state,
      clientCheckIns: action.payload || state.clientCheckIns
    }),
    [FETCH_REMAINING_SESSIONS_SUCCESS]: (state, action) => ({
      ...state,
      remainingSessions: action.payload || state.remainingSessions
    }),
    [FETCH_PIE_CHART_SUCCESS]: (state, action) => {
      const chartsData = action.payload;
      for (const key in chartsData) {
        chartsData[key] = {
          data: [["name", "value"], ...chartsData[key].data],
          formatters: chartsData[key]?.formatters
        };
      }

      return {
        ...state,
        pieCharts: chartsData || state.clientCharts
      };
    },
    [FETCH_DATA_ERROR]: (state, action) => ({
      ...state,
      haveError: true,
      error: action.payload.response.data.error
    }),
    [SET_API_ERROR]: (state, action) => ({
      ...state,
      apiError: action.payload
    })
  },
  initialState
);
